<template>
  <div v-if="rules" class="mt-4">
    <vs-row>
      <vs-button
        ref="createButton"
        id="create-button"
        class="vs-con-loading__container"
        @click="onClickCreateNewOnSubmit"
        type="relief"
        vslor="primary"
        >Add score rule</vs-button
      >

      <vs-button
        ref="createButton"
        id="create-button"
        class="vs-con-loading__container ml-3"
        @click="onClickCreateNewOnInactivity"
        type="relief"
        vslor="primary"
        >Add inactivity rule</vs-button
      >
    </vs-row>
    <!-- table -->
    <div id="data-list-list-view" class="data-list-container">
      <!-- <h3>{{ activeVenue.name }}</h3> -->

      <vs-table
        ref="table"
        v-model="selected"
        pagination
        search
        max-items="100"
        :data="rules"
        @selected="onClicked(selected)"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>

        <template slot="thead">
          <vs-th sort-key="">Name</vs-th>
          <vs-th sort-key="">Type</vs-th>
          <vs-th sort-key="">Enabled</vs-th>
          <vs-th sort-key="">Recipients</vs-th>
          <vs-th sort-key="">List types</vs-th>
          <!-- <vs-th sort-key="">Question category</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-category">
                  {{ tr.name }}
                </p>
              </vs-td>

              <vs-td>
                <vs-chip>
                  <feather-icon
                    :icon="typeDescription[tr.type].icon"
                    svg-classes="h-3 w-3 mr-1"
                  /><!--<span> {{ typeDescription[tr.type].text }}</span>-->
                </vs-chip>
              </vs-td>
              <vs-td>
                <vs-chip :color="tr.enabled | yesnocolor">
                  {{ tr.enabled | yesno }}</vs-chip
                >
              </vs-td>

              <vs-td>
                <p class="product-category">
                  {{ tr.recipientRoles.join(", ") }}
                </p>
              </vs-td>

              <vs-td>
                <div class="vx-col p-0" style="width: 3rem">
                  <vx-tooltip
                    :text="`List types: ${tr.listTypes.join(', ')}`"
                    position="bottom"
                  >
                    <p class="product-category">
                      {{ tr.listTypes.length }} lists
                    </p>
                  </vx-tooltip>
                </div>
              </vs-td>
              <!-- <vs-td>
                <vs-chip v-if="tr.listCategory != 'None'">
                  {{ tr.listCategory }}</vs-chip
                >
              </vs-td> -->
              <!-- <vs-td>
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click.stop="onClicked(tr)"
                />
              </vs-td> -->
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      selected: [],
    };
  },
  methods: {
    async onClickCreateNewOnSubmit() {
      this.$vs.dialog({
        color: "primary",
        title: `Create new rule`,
        text: "Are you sure you want to create a new rule? it will be disabled untill you enable it.",
        accept: this.createNewOnSubmit,
      });
    },
    async createNewOnSubmit() {
      const activeCountry = this.$store.getters["venues/activeCountry"];
      await this.$store.dispatch("listRules/createRule", {
        type: "onSubmitListNotificationRule",
        country: activeCountry.id,
      });
    },
    async onClickCreateNewOnInactivity() {
      this.$vs.dialog({
        color: "primary",
        title: `Create new rule`,
        text: "Are you sure you want to create a new rule? it will be disabled untill you enable it.",
        accept: this.createNewOnInactivity,
      });
    },
    async createNewOnInactivity() {
      const activeCountry = this.$store.getters["venues/activeCountry"];
      await this.$store.dispatch("listRules/createRule", {
        type: "onInactivityListNotificationRule",
        country: activeCountry.id,
      });
    },
    onClicked(rule) {
      this.$router
        .push({
          name: "manage-list-rule",
          params: { id: rule.id },
        })
        .catch(() => {});
    },
  },
  computed: {
    ...mapGetters({
      rules: "listRules/rules",
      typeDescription: "listRules/typeDescription",
    }),
  },

  async created() {
    const activeCountry = this.$store.getters["venues/activeCountry"];
    await this.$store.dispatch("listRules/getRules", activeCountry.id);
    console.log("My rules", this.rules);
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
